export enum WalletEventType {
  ASSIGNMENT = 0,
  COMPLETE_CART = 1,
  MID_TERM = 2,
  CLAIM_APPROVAL = 3,
  BULK_UPDATE = 4,
  ADJUSTED_ASSIGNMENT = 5,
  ADJUSTED_COMPLETE_CART = 6,
  ADJUSTED_MID_TERM = 7,
  ADJUSTED_CLAIM_APPROVAL = 8,
  RECALCULATE_WALLET_UPDATE = 9,
  NEWMI_WELLNESS_OFFERING = 10,
  ADJUSTED_NEWMI_WELLNESS_OFFERING = 11,
  MARKETPLACE_WELLNESS_OFFERING = 12
}

export const WalletEventTypeEnumHelper = {
  displayUnit(eventType: WalletEventType): string {
    switch (eventType) {
        case WalletEventType.ASSIGNMENT:
        case WalletEventType.COMPLETE_CART:
          return 'Enrolment-Completion';
        case WalletEventType.MID_TERM:
          return 'Mid-Term Completion';
        case WalletEventType.CLAIM_APPROVAL:
          return 'Vital Plus Claim Approval';
        case WalletEventType.BULK_UPDATE:
          return 'Bulk Update';
        case WalletEventType.ADJUSTED_ASSIGNMENT:
        case WalletEventType.ADJUSTED_COMPLETE_CART:
          return 'Adjusted Enrolment Completion';
        case WalletEventType.ADJUSTED_MID_TERM:
          return 'Adjusted Mid Term Completion';
        case WalletEventType.ADJUSTED_CLAIM_APPROVAL:
          return 'Adjusted Vital Plus Approval';
        case WalletEventType.RECALCULATE_WALLET_UPDATE:
          return 'Recalculate Wallet Update';
        case WalletEventType.NEWMI_WELLNESS_OFFERING:
          return 'NewMI Wellness Offering';
        case WalletEventType.ADJUSTED_NEWMI_WELLNESS_OFFERING:
          return 'Adjusted NewMI Wellness Offering';
        case WalletEventType.MARKETPLACE_WELLNESS_OFFERING:
          return 'Marketplace Wellness Offering';
        default:
          return '';
    }
  },
};

export enum PerformedBy {
  SELF = 'Self',
  ADMIN = 'Admin'
}
